import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { UpdateContactGroupParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { GetContactGroup } from "../queries/useGetContactGroup";
import { ListContactGroups } from "../queries/useListContactGroups";

export const UpdateContactGroup = graphql(/* GraphQL */ `
	mutation UpdateContactGroup($params: UpdateContactGroupParams!) {
		updateContactGroup(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useUpdateContactGroup() {
	const [updateContact] = useMutation(UpdateContactGroup, {
		refetchQueries: [GetContactGroup, ListContactGroups],
	});

	const handleUpdateContactGroup = useCallback(
		async (params: UpdateContactGroupParams) => {
			const result = await updateContact({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.updateContactGroup.success,
				error: result.data?.updateContactGroup.error,
			};
		},
		[updateContact]
	);

	return { handleUpdateContactGroup };
}
